import React, { FC } from "react";
import { Checkbox } from "@ftdr/blueprint-components-react";
import { WalletCheckboxValue } from "../../types";

type WalletCheckboxProps = {
  label?: string;
  isChecked: boolean;
  isDisabled?: boolean;
  onCheckedChange: (value: boolean) => void;
  showWalletCheckbox: WalletCheckboxValue;
};
export const WalletCheckbox: FC<WalletCheckboxProps> = ({
  label,
  isChecked,
  isDisabled,
  onCheckedChange,
  showWalletCheckbox,
}) => {
  return (
    <div className={`w-full`}>
      <Checkbox
        label={
          label ||
          (showWalletCheckbox === WalletCheckboxValue.SET_AS_DEFAULT
            ? "Save As Default"
            : "Save In Wallet")
        }
        disabled={isDisabled}
        checked={isChecked}
        data-testid={`Payment__Checkbox_${showWalletCheckbox}`}
        onChange={() => onCheckedChange(isChecked)}
      />
    </div>
  );
};
